import { Link, Modal, Typography } from '@mui/material'
import { Box } from '@mui/system'
import React, { useState } from 'react'
import styles from "../laymanmain.module.css"
import CloseIcon from "@mui/icons-material/Close";
import MembershipModal from "../../../components/Modal/MembershipModal"
import Common_html from "./Common_html";
import BlockData from "../../../layman-explanation-json/introduction.json";
import Head from "next/head";
export default function LaymanPage1() {

  const [membershipOpen, setMembershipOpen] = useState(false);
  const memberfunc = () => {
    setMembershipOpen(true);
  };
  
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>

    {/* <Head>
  <title>ROTA, The Wheel of Astrological Tarot | School of Our Divine Infinite Being</title>
  <meta name="viewport" content="width=device-width, initial-scale=1.0" />

  <meta
    name="keywords"
    content="ROTA, Astrological Tarot, Rota Tarot, Divine Arcana, Mystery School, Astrology, Jungian Archetypes, Platonic Kabbalah, Rosicrucianism, Freemasonry, Eliphas Lévi, Golden Dawn, Aleister Crowley, Thoth Tarot, Tarot History, Western Esotericism, Divine Theurgy, Esoteric Tarot, Zodiac, Planets, Divine Infinite Being"
  />

  <meta
    name="description"
    content="Explore the deep symbolism, history, and esoteric traditions behind the ROTA — the Wheel of Astrological Tarot. Discover how astrology, psychology, and mysticism merge with the rich heritage of the Golden Dawn, Rosicrucianism, and Aleister Crowley in the Divine Arcana taught at the School of Our Divine Infinite Being."
  />

  <meta property="og:title" content="ROTA, The Wheel of Astrological Tarot | School of Our Divine Infinite Being" />
  <meta property="og:type" content="website" />
  <meta
    property="og:image"
    content="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/School_Layman_Explanation.png"
  />
  <meta
    property="og:image:alt"
    content="A vibrant and intricate esoteric wheel combining zodiac signs, tarot archetypes, planetary symbols, and color-coded correspondences, reflecting the integration of cosmic forces, psychology, and sacred traditions."
  />
  <meta
    property="og:description"
    content="Delve into the symbolism and lineage of the ROTA, uniting astrology, tarot, and Western mystery traditions from the Rosicrucians and Golden Dawn to Aleister Crowley. Study the Divine Arcana at the School of Our Divine Infinite Being."
  />
  <meta property="og:image:width" content="1200" />
  <meta property="og:image:height" content="627" />
  <meta
    property="og:url"
    content="https://www.divineinfinitebeing.com/layman-explanation?chapter=1"
  />

  <meta name="twitter:card" content="summary_large_image" />
  <meta
    property="twitter:image"
    content="https://all-frontend-assets.s3.us-east-1.amazonaws.com/transcendentpagan/transcendentpagan_ui_next/og_img/School_Layman_Explanation.png"
  />
  <meta
    property="twitter:image:alt"
    content="A vibrant and intricate esoteric wheel combining zodiac signs, tarot archetypes, planetary symbols, and color-coded correspondences, reflecting the integration of cosmic forces, psychology, and sacred traditions."
  />
  <meta
    name="twitter:url"
   content="https://www.divineinfinitebeing.com/layman-explanation?chapter=1"
  />
  <meta
    name="twitter:title"
    content="ROTA, The Wheel of Astrological Tarot | School of Our Divine Infinite Being"
  />
  <meta
    name="twitter:description"
    content="Explore the symbolism, psychology, and history of the ROTA, the Wheel of Astrological Tarot — from Jungian archetypes and Kabbalah to the Golden Dawn and Aleister Crowley. Learn the Divine Arcana in our Mystery School."
  />
  <link rel="canonical" href="https://www.divineinfinitebeing.com/layman-explanation?chapter=1" />
</Head> */}

       <Common_html BlockData={BlockData} />


    </>
  )
}
